div(v-if='bidder.anonymous || !bidder.pictureUrl' :style='{ background: dynamicHash, width: "100%", height: "100%", display: "flex", "justify-content": "center", "align-items": "center" }' data-test='anonymous-picture')
  span {{ bidder.firstName?.charAt(0).toLocaleUpperCase() }}
FanImageVue(v-else :url='bidder.pictureUrl')
